import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import Game from '../../components/Game';
import { useParams } from 'react-router-dom';
import FanAnswersStore from '../../models/fanAnswersStore/fanAnswers';
import translations from '../../translations/de';
import Paths from '../../constants/paths';

const FanGame = ({ store }) => {
    const { season_id, fan_game_id } = useParams();
    const fanAnswers = FanAnswersStore.create();

    useEffect(() => {
        store.getGame(season_id, fan_game_id);
    }, [store, season_id, fan_game_id]);

    return store.selectedGame ? (
        <Game
            store={store}
            links={[
                {
                    path: Paths.SEASONS,
                    name: translations.seasons,
                    onThisLinkClick: () => {
                        store.selectGame(undefined);
                    },
                },
                {
                    path: `/seasons/${store.selectedSeason.id}`,
                    name: store.selectedSeason.title,
                },
            ]}
            fanAnswers={fanAnswers}
        />
    ) : null;
};

export default observer(FanGame);
